<template>
  <div class="left-nav-menu-container">
    <div class="left-nav-menu-background" @click="$emit('close')"></div>
    <div class="left-nav-menu">
      <div class="profile-info">
        <div class="profile-image">
          <fa-icon icon="user"></fa-icon>
        </div>
        <div class="profile-name" v-if="profile">
          {{ profile.firstName }} {{ profile.lastName }}
        </div>
      </div>

      <div class="box is-shadowless">
        <aside class="menu">
          <ul class="menu-list">
            <menu-item icon="search" label="Search" :to="{ name: 'Search' }"></menu-item>
          </ul>
        </aside>

        <aside class="menu" v-if="showCustomerService">
          <p class="menu-label">Customer Service</p>
          <ul class="menu-list">
            <menu-item :label="toTitleCase(object)" v-for="object of CustomerServiceTypes" :key="object">
              <menu-item label="Search" icon="search" :to="$entity.toSearchRoute(object)" exact></menu-item>
              <menu-item label="Create" icon="plus" :to="$entity.toCreateRoute(object)" exact
                v-if="object !== 'PickupLocation'"
              ></menu-item>
            </menu-item>
          </ul>
        </aside>

        <aside class="menu" v-if="showDispatcher">
          <p class="menu-label">Dispatcher</p>
          <ul class="menu-list">
            <menu-item label="Customer">
              <menu-item label="Search" icon="search" :to="$entity.toSearchRoute('Customer')" exact></menu-item>
              <menu-item label="Create" icon="plus" :to="$entity.toCreateRoute('Customer')" exact></menu-item>
            </menu-item>
            <menu-item label="Dumpster">
              <menu-item label="Search" icon="search" :to="$entity.toSearchRoute('Dumpster')" exact></menu-item>
              <menu-item label="Create" icon="plus" :to="$entity.toCreateRoute('Dumpster')" exact></menu-item>
            </menu-item>
            <ul class="menu-list">
              <menu-item label="Pickup Locations" :to="{ name: 'Search Pickup Location' }" exact></menu-item>
            </ul>
            <menu-item label="Pickup Request">
              <menu-item label="Search" icon="search" :to="$entity.toSearchRoute('PickupRequest')" exact></menu-item>
              <menu-item label="Create" icon="plus" :to="$entity.toCreateRoute('PickupRequest')" exact></menu-item>
            </menu-item>
            <menu-item label="Route">
              <menu-item label="Search" icon="search" :to="$entity.toSearchRoute('Route')" exact></menu-item>
              <menu-item label="Create" icon="plus" :to="$entity.toCreateRoute('Route')" exact></menu-item>
              <menu-item label="Mapper" icon="map" :to="{ name: 'Route Mapper' }" exact></menu-item>
            </menu-item>
            <menu-item label="Truck">
              <menu-item label="Search" icon="search" :to="$entity.toSearchRoute('Truck')" exact></menu-item>
              <menu-item label="Create" icon="plus" :to="$entity.toCreateRoute('Truck')" exact></menu-item>
            </menu-item>
            <menu-item label="Work Item">
              <menu-item label="Search" icon="search" :to="$entity.toSearchRoute('WorkItem')" exact></menu-item>
              <menu-item label="Create" icon="plus" :to="$entity.toCreateRoute('WorkItem')" exact></menu-item>
            </menu-item>
          </ul>
        </aside>

        <aside class="menu" v-if="showAdmin">
          <p class="menu-label">Admin</p>
          <ul class="menu-list">
            <menu-item label="Animals">
              <menu-item label="Search" icon="search" :to="$entity.toSearchRoute('Animal')" exact></menu-item>
              <menu-item label="Create" icon="plus" :to="$entity.toCreateRoute('Animal')" exact></menu-item>
            </menu-item>
            <menu-item label="Plastic Products">
              <menu-item label="Search" icon="search" :to="$entity.toSearchRoute('PlasticProduct')" exact></menu-item>
              <menu-item label="Create" icon="plus" :to="$entity.toCreateRoute('PlasticProduct')" exact></menu-item>
            </menu-item>
            <menu-item label="Roles">
              <menu-item label="Search" icon="search" :to="$entity.toSearchRoute('Role')" exact></menu-item>
              <menu-item label="Create" icon="plus" :to="$entity.toCreateRoute('Role')" exact></menu-item>
            </menu-item>
            <menu-item label="Campaigns">
              <menu-item label="Search" icon="search" :to="$entity.toSearchRoute('Campaign')" exact></menu-item>
              <menu-item label="Create" icon="plus" :to="$entity.toCreateRoute('Campaign')" exact></menu-item>
            </menu-item>
            <menu-item label="Collection Locations">
              <menu-item label="Search" icon="search" :to="$entity.toSearchRoute('CollectionLocation')" exact></menu-item>
              <menu-item label="Create" icon="plus" :to="$entity.toCreateRoute('CollectionLocation')" exact></menu-item>
            </menu-item>
          </ul>
          <ul class="menu-list">
            <menu-item label="Accounts" :to="{ name: 'Search Account' }" exact></menu-item>
          </ul>
          <ul class="menu-list">
            <menu-item label="Districts" :to="{ name: 'Search District' }" exact></menu-item>
          </ul>
          <ul class="menu-list">
            <menu-item label="Regions" :to="{ name: 'Search Region' }" exact></menu-item>
          </ul>
        </aside>

          <p class="menu-label">User Settings</p>
          <ul class="menu-list">
            <menu-item label="Settings" :to="{ name: 'Settings' }" exact></menu-item>
            <li><a @click.prevent="onLogout">Logout</a></li>
          </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Library from '@/library'
import MenuItem from './MenuItem.vue'

export default {
  name: 'TheLeftNavMenu',

  methods: {
    toTitleCase (value) {
      return Library.Filters.toTitleCase(value)
    },

    async onLogout () {
      const loader = this.$loading.open()
      try {
        await this.$store.dispatch('auth/logout')
      } finally {
        this.$router.push({ name: 'Login' })
        loader.close()
      }
    }
  },

  computed: {
    showCustomerService () {
      return true
    },

    CustomerServiceTypes () {
      return [
        Library.Enums.ObjectType.Customer,
        Library.Enums.ObjectType.PickupLocation,
        Library.Enums.ObjectType.Dumpster,
        Library.Enums.ObjectType.WorkItem
      ]
    },

    showDispatcher () {
      return true
    },

    showAdmin () {
      // TODO use Role to determine is can see Admin
      return true
    },

    AdminTypes () {
      return [
        Library.Enums.ObjectType.Animal,
        Library.Enums.ObjectType.PlasticProduct,
        Library.Enums.ObjectType.Campaign,
        Library.Enums.ObjectType.Account
      ]
    },

    profile () {
      try {
        return this.$store.getters['auth/Profile']
      } catch (e) {
        return null
      }
    }
  },

  components: {
    MenuItem
  }
}
</script>

<style lang="scss" scoped>
  .box {
    .menu {
      margin-bottom: .5rem;
    }
  }
</style>
